import { render, staticRenderFns } from "./mapAddLamp.vue?vue&type=template&id=247062f9&scoped=true&"
import script from "./mapAddLamp.vue?vue&type=script&lang=js&"
export * from "./mapAddLamp.vue?vue&type=script&lang=js&"
import style0 from "./mapAddLamp.vue?vue&type=style&index=0&id=247062f9&lang=less&scoped=true&"
import style1 from "./mapAddLamp.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247062f9",
  null
  
)

export default component.exports